<h2 mat-dialog-title>Re-authentication</h2>
<mat-dialog-content>
    In order to perform this action, you need to re-authenticate.
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="onSubmit()">Authorise</button>
</mat-dialog-actions>
